const { getCookie } = require('./browserData');
const { COOKIES } = require('../constants');
const { decodeBase64 } = require('../utils/decoder');

const getDefaultZone = require('../apis/getDefaultZone');

function getZoneId(tenantId, catalystBaseUrl = '') {
  const zoneDataCookie = getCookie(COOKIES.ZONE_DATA);
  const { changed: zoneDataChanged, zoneID: zoneDataZoneId } = decodeBase64(zoneDataCookie);
  if (zoneDataChanged && zoneDataZoneId) return zoneDataZoneId;

  const locationDataCookie = getCookie(COOKIES.LOCATION_DATA);
  const { loginStatus, availableZone: locationDataZoneId } = decodeBase64(locationDataCookie);
  if (loginStatus === 'falabella logged in' && locationDataZoneId) return locationDataZoneId;

  const customerDataCookie = getCookie(COOKIES.CUSTOMER_DATA);
  const { addressRegion: customerDataZoneId } = decodeBase64(customerDataCookie);
  if (zoneDataCookie && customerDataZoneId) return customerDataZoneId;

  if (zoneDataZoneId) return zoneDataZoneId;

  return getDefaultZone(tenantId, catalystBaseUrl);
}

module.exports = getZoneId;
